import { useGlobalContext } from '~/lib/contexts/GlobalContext';
import { useMemo } from 'react';
import type { FireflyTertiaryButtonMenuItem } from '@equip.health/ui';
import { MaudPermissions } from '~/lib/constants/permissions.constants';
import util from '~/components/common/calendar/util';
import { NoteFormDefaultSessionLink } from '~/components/maud/patients/note/editNoteForm.util';

type Props = {
  patientAppointments?: GetAppointmentDetailsResponse;
  selectedAppointmentDetails?: AppointmentDetailResponse;
  selectedAppointmentId?: string;
};

export const useNoteFormSessionListOptions = ({
  patientAppointments,
  selectedAppointmentDetails,
  selectedAppointmentId,
}: Props) => {
  const {
    currentUser: { userId: currentUserId },
    permissions,
  } = useGlobalContext();

  const sessionDetailsListOptions = useMemo<
    FireflyTertiaryButtonMenuItem[]
  >(() => {
    const filteredAppointments = (patientAppointments?.data ?? [])
      .filter((appointmentData: AppointmentDetailResponse) => {
        const isHost = appointmentData.host.externalId === currentUserId;
        const isAttendee = appointmentData.providerAttendees?.some(
          (attendee) => attendee.externalId === currentUserId,
        );
        return (
          isHost ||
          (isAttendee && permissions[MaudPermissions.MAUD_SCHEDULE_PROXY])
        );
      })
      .map((appointmentData) =>
        util.convertAppointmentDataToButtonMenuItem(appointmentData),
      );
    if (
      selectedAppointmentDetails &&
      selectedAppointmentId ===
        selectedAppointmentDetails.appointmentExternalId &&
      !filteredAppointments.find(
        (appt) =>
          appt.node === selectedAppointmentDetails.appointmentExternalId,
      )
    ) {
      filteredAppointments.push(
        util.convertAppointmentDataToButtonMenuItem(selectedAppointmentDetails),
      );
    }
    return [...filteredAppointments, NoteFormDefaultSessionLink];
  }, [
    patientAppointments,
    selectedAppointmentDetails,
    selectedAppointmentId,
    currentUserId,
  ]);

  return { sessionDetailsListOptions };
};
